import { render, staticRenderFns } from "./HQApprovalGRDetail.vue?vue&type=template&id=c72d16ce&scoped=true"
import script from "./HQApprovalGRDetail.vue?vue&type=script&lang=js"
export * from "./HQApprovalGRDetail.vue?vue&type=script&lang=js"
import style0 from "./HQApprovalGRDetail.vue?vue&type=style&index=0&id=c72d16ce&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c72d16ce",
  null
  
)

export default component.exports